/**
 * Matches the ASCII dot-atom format used by veo-customer and customer-api-gateway EmailUtil.
 * Required/optional fields and company-domain restrictions remain the caller's responsibility.
 * The final assertion makes JavaScript's end anchor strict, like Java Matcher.matches().
 */
export const EMAIL_PATTERN = /^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$(?![\s\S])/;
